import { getProductPageEntries, type ProductPageSelection } from '../getProductPageEntries';

export const getProductCategoriesAmount = (page: ProductPageSelection): number =>
  getProductPageEntries({ productCategories: page.productCategories }).length;
